module.exports = __webpack_public_path__ + "assets/3324de44bf3c81d80d95aaef6e5fbf8b.svg";